module.exports = __webpack_public_path__ + "img/Individual.96920710.svg";